module.exports = __webpack_public_path__ + "media/components/country-flag/static/uy-e6ac471da67fa86be07c59ba63e0380d.svg";